/** Tabla MSP # Tratamiento — sesiones con fecha, diagnóstico, procedimientos, etc. */

export const MSP_TRAT_ROW_BLANK = {
  fecha: '',
  diagnostico: '',
  tratamiento: '',
  prescripciones: '',
  codigo: '',
  firma: '',
  codigoFirma: '',
};

export const MSP_TRAT_MIN_SESIONES = 2;

function mergeCodigoFirma(row) {
  const codigo = String(row?.codigo ?? '').trim();
  const firma = String(row?.firma ?? '').trim();
  const legacy = String(row?.codigoFirma ?? '').trim();
  if (codigo || firma) {
    return [codigo, firma].filter(Boolean).join(' | ');
  }
  return legacy;
}

function splitCodigoFirma(legacy) {
  const s = String(legacy || '').trim();
  if (!s) return { codigo: '', firma: '' };
  const pipe = s.indexOf('|');
  if (pipe >= 0) {
    return { codigo: s.slice(0, pipe).trim(), firma: s.slice(pipe + 1).trim() };
  }
  return { codigo: s, firma: '' };
}

export function tratamientoSesionTieneDatos(row) {
  if (!row) return false;
  return !!(
    String(row.fecha || '').trim() ||
    String(row.diagnostico || '').trim() ||
    String(row.tratamiento || '').trim() ||
    String(row.prescripciones || '').trim() ||
    String(row.codigo || '').trim() ||
    String(row.firma || '').trim() ||
    String(row.codigoFirma || '').trim()
  );
}

export function tratamientosConDatos(rows) {
  return sanitizeTablaTratamientosMSP(rows).filter(tratamientoSesionTieneDatos);
}

function mapTratamientoRow(r, { trim = false } = {}) {
  const norm = (v) => {
    const s = String(v ?? '');
    return trim ? s.trim() : s;
  };
  const split = splitCodigoFirma(r?.codigoFirma);
  const codigo = r?.codigo !== undefined ? norm(r.codigo) : norm(split.codigo);
  const firma = r?.firma !== undefined ? norm(r.firma) : norm(split.firma);
  const row = {
    fecha: norm(r?.fecha),
    diagnostico: norm(r?.diagnostico),
    tratamiento: norm(r?.tratamiento),
    prescripciones: norm(r?.prescripciones),
    codigo,
    firma,
    codigoFirma: '',
  };
  row.codigoFirma = mergeCodigoFirma(row);
  return row;
}

/** Estructura mínima sin recortar espacios — usar mientras el usuario escribe. */
export function ensureTablaTratamientosMSPStructure(rows) {
  const arr = Array.isArray(rows) ? rows : [];
  const out = arr.map((r) => mapTratamientoRow(r, { trim: false }));
  const base = out.length ? out : [{ ...MSP_TRAT_ROW_BLANK }];
  while (base.length < MSP_TRAT_MIN_SESIONES) {
    base.push({ ...MSP_TRAT_ROW_BLANK });
  }
  return base;
}

/** Normaliza y recorta espacios — solo al cargar o guardar. */
export function sanitizeTablaTratamientosMSP(rows) {
  const arr = Array.isArray(rows) ? rows : [];
  const out = arr.map((r) => mapTratamientoRow(r, { trim: true }));
  const base = out.length ? out : [{ ...MSP_TRAT_ROW_BLANK }];
  while (base.length < MSP_TRAT_MIN_SESIONES) {
    base.push({ ...MSP_TRAT_ROW_BLANK });
  }
  return base;
}

export function patchTratamientoRow(prev, index, patch) {
  const rows = ensureTablaTratamientosMSPStructure(prev);
  const next = rows.map((r, i) => {
    if (i !== index) return r;
    const merged = { ...r, ...patch };
    merged.codigoFirma = mergeCodigoFirma(merged);
    return merged;
  });
  return next;
}
